import { gql } from '__generated__';

export const MessageRecipientsAttributesFragment = gql(`
  fragment MessageRecipientsAttributes on Message {
    id
    scheduled_at
    remaining_count
    recipient_count
    next_recipient_count
    previous_recipient_count
  }
`);

export default gql(`
  query GetMessageRecipients($project_id: ID!, $message_id: ID!) {
    project(id: $project_id) {
      id
      message(id: $message_id) {
        ...MessageRecipientsAttributes
      }
    }
  }
`);
